import { render, staticRenderFns } from "./AddMassivePersonSkill.vue?vue&type=template&id=0a87c5c3"
import script from "./AddMassivePersonSkill.vue?vue&type=script&lang=js"
export * from "./AddMassivePersonSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports